import { SharedAppConstants } from '@tock/shared-app-constants';
import { core, toJSONArray } from '@tock/coretypes';

interface State {
  isInitialized: boolean;
  patronsMatchingEmail: core.Patron[];
  isRequestInProgress: boolean;
}

const initialState: State = {
  isInitialized: false,
  patronsMatchingEmail: [],
  isRequestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.PATRON_SEARCH_DONE: {
      return {
        ...state,
        patronsMatchingEmail: toJSONArray<core.Patron>(payload),
        isInitialized: true,
        isRequestInProgress: false,
      };
    }
    case SharedAppConstants.PATRON_SEARCH_STARTING:
      return {
        ...state,
        isInitialized: false,
        isRequestInProgress: true,
      };
    case SharedAppConstants.PATRON_SEARCH_FAILED:
    case SharedAppConstants.PATRON_SEARCH_CLEAR:
      return {
        ...state,
        ...initialState,
        isRequestInProgress: false,
      };
    default:
      return state;
  }
}
